import { Route } from 'react-router-dom';
import { checkPortalPermissions } from '../../../libs/functions/global.functions';
import { isEdoFeatureExcludeVisible } from 'libs/edoNavFeatureVisibility';
import FeatureNotAvailable from '../FeatureNotAvailable';
import PrivateContainer from './PrivateContainer';
import userAccountSignal from 'signals/UserAccount.signal';

const withPrivateRoute =
  (allowedPortal) =>
  // eslint-disable-next-line react/display-name
  ({ component: Component, ...rest }) => {
    const userData = userAccountSignal.value.userData;
    const role = userData?.role;

    const excludeFeature = !isEdoFeatureExcludeVisible(
      {
        featureExclude: rest.featureExclude,
        allowStaffWithProgramAccess: rest.allowStaffWithProgramAccess,
      },
      userData
    );

    if (!role) {
      return null;
    }

    return (
      <Route
        {...rest}
        render={(props) =>
          checkPortalPermissions(allowedPortal) ? (
            <PrivateContainer portal={allowedPortal}>
              {excludeFeature ? (
                <FeatureNotAvailable />
              ) : (
                <Component {...props} />
              )}
            </PrivateContainer>
          ) : (
            <div>Not permitted</div>
          )
        }
      />
    );
  };

export default withPrivateRoute;
